import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icons, Tooltip, Typography } from '../../atoms';
import { ContainerV2 } from '../../atoms/containerV2/ContainerV2';
import { commonTranslations } from '../../../translations';
import { Spacing } from '../../../utils';
import { StyledIconWithText } from './Copy.styles';

type CopyProps = {
  textToCopy: string;
  size?: 'small' | 'medium' | 'large';
  margin?: Spacing;
};

const Copy: FC<CopyProps> = ({ textToCopy, size = 'small', margin }) => {
  const { t } = useTranslation();
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 1500);
    } catch (err) {
      console.error('Copy failed', err);
    }
  };

  return (
    <ContainerV2 margin={margin}>
      <Tooltip
        position="right-end"
        arrowedToolTip
        isVisible={!isCopied}
        text={
          <ContainerV2>
            <Typography type="legal" color="white">
              {t(commonTranslations.copy.key, commonTranslations.copy.defaultValue)}
            </Typography>
          </ContainerV2>
        }
      >
        <div>
          <StyledIconWithText
            data-testid="copy-icon"
            isTextCopied={isCopied}
            label={isCopied ? `${t(commonTranslations.copied.key, commonTranslations.copied.defaultValue)}` : ''}
            iconOptions={{
              icon: isCopied ? Icons.CHECK_MARK : Icons.COPY,
              size: size,
            }}
            spaceBetween="small"
            onClick={handleCopy}
          />
        </div>
      </Tooltip>
    </ContainerV2>
  );
};

export default Copy;
